// System
import { Button, Typography } from '@mui/material';

// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';

// Redux
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'src/app/store';

// Styles
import Styles from './DeleteUserModalDialog.module.scss';
import { useUserDrawer } from '@Modal/hooks/users/useUserDrawer';

export const DeleteUserModalDialog = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    showDeleteUserModal,
    setShowDeleteUserModal,
    selectedUser,
    handleDeleteUser,
  } = useUserDrawer();
  return (
    <ClosableModal
      name="deleteUserModalDialog"
      title="Confirmation"
      open={showDeleteUserModal}
      onClose={() => dispatch(setShowDeleteUserModal(false))}
      className={Styles.DeleteUserModalDialog}
      sx={{ width: '592px' }}
    >
      <>
        <CreateDialogLayout>
          <Typography variant="body2">
            Are you sure you want delete {selectedUser && `${selectedUser?.email}`}
          </Typography>
          <CreateDialogFooterLayout>
            <AtLocator type="button" name="Cancel">
              <Button
                variant="outlined"
                color="inherit"
                onClick={() => dispatch(setShowDeleteUserModal(false))}
              >
                Cancel
              </Button>
            </AtLocator>
            <AtLocator type="button" name="Submit">
              <Button
                type="submit"
                color="error"
                variant="contained"
                onClick={handleDeleteUser}
              >
                Delete
              </Button>
            </AtLocator>
          </CreateDialogFooterLayout>
        </CreateDialogLayout>
      </>
    </ClosableModal>
  );
};
